import FeatCard from '@/components/pages/home/HomeContent/Features/FeatCard';
import styles from './styles.module.css';
import { blogBg } from '@/functions/formats';
import ServiceSectionHead from '../ServiceSectionHead';

const steps = [
  {
    id: 1,
    icon: 1,
    t: 'پذیرش و ثبت کیلومتر',
    d: 'خودرو پذیرش و وضعیت اولیه در پروندهٔ کارا ثبت می‌شود.',

    // badgeClass: styles.orange,
  },
  {
    id: 2,
    icon: 2,
    t: 'تخلیهٔ روغن سوخته',
    d: 'روغن قدیم کامل تخلیه و واشر کارتل بازرسی می‌شود.',
    // badgeClass: styles.blue,
  },
  {
    id: 3,
    icon: 3,
    t: 'تعویض فیلتر و شارژ روغن',
    d: 'فیلتر اصلی نصب و روغن نو تا سطح استاندارد پر می‌شود.',
    // badgeClass: styles.purple,
  },
  {
    id: 4,
    icon: 4,
    t: 'بازرسی ۱۲ نقطه و تحویل',
    d: 'مایعات، لاستیک و چراغ‌ها بازرسی و گزارش تحویل می‌شود.',
    // badgeClass: styles.green,
  },
];

export default function ServiceProcessSteps() {
  return (
    <div className={`card ${styles.container}`}>
      <ServiceSectionHead title="مراحل انجام کار"></ServiceSectionHead>

      <div className={styles.grid}>
        {steps?.map((step, index) => (
          <FeatCard
            key={index}
            f={{ ...step, bg: blogBg(index) }}
            bg={'lightGray'}
            showNumber={false}
            index={index}
            fill={'var(--paper)'}
            iconSize="30px"
            iconClassName={styles.badge}
            titleClass={`${styles.title}`}
            textClass={`${styles.description}`}
            movingCard={false}
          />
        ))}
      </div>
    </div>
  );
}
